// extracted by css-extract-rspack-plugin
export default {"quantity":"quantity-nfE39W text-base-semibold","quantityPositive":"quantityPositive-tM9hZJ","quantityNegative":"quantityNegative-raBKCM"};